import { connect, MapStateToProps } from "react-redux";

import { getPrimaryText } from "@multiweb/reactCore/i18n";
import { IAppState, NoneOwnProps } from "@multiweb/types/react";
import { LOC_DELETE, LOC_EDIT, LOC_PRINT, LOC_SET, LOC_SET_SETTINGS } from "../../locKeys";
import { SetSettingsDropdownSelectComponent, SetSettingsDropdownSelectComponentProps } from "./SetSettingsDropdownSelectComponent";

type StateProps = Pick<SetSettingsDropdownSelectComponentProps, "editText" | "deleteText" | "printText" | "setText" | "setSettingsText">;

const mapStateToProps: MapStateToProps<StateProps, NoneOwnProps, IAppState> = (state) => ({
    editText: getPrimaryText(state, LOC_EDIT) ?? "Upravit",
    deleteText: getPrimaryText(state, LOC_DELETE) ?? "Smazat",
    printText: getPrimaryText(state, LOC_PRINT) ?? "Tisk",
    setText: getPrimaryText(state, LOC_SET) ?? "SADA",
    setSettingsText: getPrimaryText(state, LOC_SET_SETTINGS) ?? "Nastavení sady",
});

export const SetSettingsDropdownSelect = connect(mapStateToProps)(SetSettingsDropdownSelectComponent);
